import './formButtons.scss';

import * as React from 'react';

export interface FormButtonsProps {
    className?: string,
    children: React.ReactNode
}

/**
 * Container for buttons (e.g. sumbit) at the bottom of a form. 
 */
export const FormButtons = (props: FormButtonsProps) => {
    const { className, children } = props;

    return (
        <div className={`form-buttons ${className ?? ''}`}>
            {children}
        </div>
        );
};